export function Producer() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Producer dashboard</h1>
      <p>Em construção — plano P-prod futuro.</p>
    </div>
  );
}
